import React from 'react'
import { Paper } from '@mui/material'
import classNames from 'classnames'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import RoomsStatsItemList from './RoomsStatsItemList/RoomsStatsItemList'

interface Props {
  classes: Record<string, string>,
  RoomsStatsItems: any[],
  isRoomsStatsPopupOpen: boolean,
  isMobile: boolean,
  openRoomStatsPopup: (...args: any[]) => void,
  closeRoomStatsPopup: (...args: any[]) => void,
  selectCurrentRoomIdAndName: (...args: any[]) => void,
  syncCurrentRoomStats: (...args: any[]) => void,
}

class RoomsStats extends React.Component<Props> {
  static displayName = 'RoomsStats'

  componentWillUnmount() {
    const { closeRoomStatsPopup } = this.props
    closeRoomStatsPopup()
  }

  render() {
    const {
      classes,
      RoomsStatsItems,
      isMobile,
      isRoomsStatsPopupOpen,
      openRoomStatsPopup,
      selectCurrentRoomIdAndName,
      syncCurrentRoomStats,
    } = this.props
    return (
      <Paper className={classNames(
        classes.main,
        !isMobile && classes.mainDesktop,
        (navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))
          && classes.webView,

      )}
      >
        <Wrapper className={classes.wrapper}>
          <RoomsStatsItemList
            className={classes.itemList}
            RoomsStatsItems={RoomsStatsItems}
            isRoomsStatsPopupOpen={isRoomsStatsPopupOpen}
            isMobile={isMobile}
            openRoomStatsPopup={openRoomStatsPopup}
            selectCurrentRoomIdAndName={selectCurrentRoomIdAndName}
            syncCurrentRoomStats={syncCurrentRoomStats}
          />
        </Wrapper>
      </Paper>
    )
  }
}

export default RoomsStats
